// extracted by mini-css-extract-plugin
export default {"minesSubmitButtonWrap":"styles_minesSubmitButtonWrap__I-KJe","minesSubmitButton":"styles_minesSubmitButton__Rliyf"};